<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import PrintParametersSettings from '../printParameters/PrintParametersSettings.vue'
import LargeTabHeader from "@/components/common/tabs/LargeTabHeader.vue";

export default {
  name: 'PrintParameters',
  components: {
    LargeTabHeader,
    PrintParametersSettings,
  },
  props: {
    fillWidth: {
      type: Boolean
    }
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState({
      userSettings: state => state.settings
    }),
    ...mapGetters(['isLocked'])
  },
  methods: {
    ...mapActions(['saveUserSettings']),
    handleClick() {
      this.loading = true
      //below save function will call setUserSettings in store
      this.saveUserSettings({
        printMode: this.userSettings.printMode,
        colorMode: this.userSettings.colorMode,
        frankingType: this.userSettings.frankingType
          ? this.$enums.FrankingType.Envelope
          : this.$enums.FrankingType.DVFr,
        confirmProductionArea: this.userSettings.confirmProductionArea,
        confirmFontWarnings: this.userSettings.confirmFontWarnings,
        orderSchedule: this.userSettings.orderSchedule,
        merge: {
          address: this.userSettings.merge.address,
          custom: this.userSettings.merge.custom
        },
        foldType: this.userSettings.foldType,
        defaultCostCenter: this.userSettings.defaultCostCenter
      })
      .then(() => {
        this.$notify(this.$t('component.profile.printParameters.save.success'), {type: 'success'})
      })
      .catch(() => {
        this.$notify(this.$t('component.profile.printParameters.save.error'), {type: 'error'})
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<template>
  <v-container fluid>
  <!--    HEADER-->
  <LargeTabHeader
    :title="$t('component.profile.tabs.printParametersTab.params.header')"
    :subtitle="$t('component.profile.tabs.printParametersTab.params.info.text')"/>

  <v-divider></v-divider>

  <!--PRINT PARAMETER SETTINGS-->
  <v-row>
    <v-col>
      <PrintParametersSettings
        v-model="userSettings"
        :fill-width="fillWidth"
        :locked="isLocked"/>
    </v-col>
  </v-row>

  <!--SAVE BUTTON-->
  <v-row>
    <v-col class="justify-center text-center">
      <v-btn
        v-if="!isLocked"
        id="saveParams"
        class="text-center px-8"
        color="primary"
        :loading="loading"
        depressed
        fluid
        @click.stop="handleClick">
        <v-icon>mdi-check</v-icon>
        {{ $t('button.save.standards') }}
      </v-btn>
    </v-col>
  </v-row>
  </v-container>
</template>
<style lang="scss">
.information-icon {
  opacity: 0 !important;

  &.on-hover {
    opacity: 1 !important;
    transition: 0.5s ease-in-out;
  }
}
</style>
